import { render, staticRenderFns } from "./continue.vue?vue&type=template&id=0536e43e&scoped=true&"
import script from "./continue.vue?vue&type=script&lang=js&"
export * from "./continue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536e43e",
  null
  
)

export default component.exports